import * as React from 'react';
import { FormLayoutWidget } from './FormLayoutWidget';
import { useProductConfig } from '../../hooks/useProduct';
import { ProTipWidget } from '../ProTipWidget';
import { CenterFormWidget } from './CenterFormWidget';
import { CarouselWidget } from '../CarouselWidget';

export interface MarketingScreenWidgetProps {
  title: string;
  subheading: string;
  content: JSX.Element[];
}

export const MarketingScreenWidget: React.FC<MarketingScreenWidgetProps> = (props) => {
  const product = useProductConfig();
  return (
    <CenterFormWidget primaryLabel={props.title} secondaryLabel={props.subheading}>
      <FormLayoutWidget
        sections={[
          {
            key: 'content',
            elements: props.content
          },
          {
            key: 'tip',
            elements: [
              <CarouselWidget
                content={product.tips.map((m, index) => {
                  return (
                    <ProTipWidget key={`marketing-${m.title}-${index}`} title={m.title} description={m.description} />
                  );
                })}
              />
            ]
          }
        ]}
      />
    </CenterFormWidget>
  );
};
